import Vue from 'vue'
import Router from 'vue-router'
 
import index from '@/pages/home/index'
import select_template from '@/pages/sms/select_template'
import select_add from '@/pages/sms/select_add'
import import_data from '@/pages/sms/import_data'
import import_key from '@/pages/sms/import_key'
import import_data2 from '@/pages/sms/import_data2'
import import_key2 from '@/pages/sms/import_key2'
import view_results from '@/pages/sms/view_results'
import view_results2 from '@/pages/sms/view_results2'
import view_results3 from '@/pages/sms/view_results3'
import store from '@/pages/store/index'
import send_result from '@/pages/sms/send_result'
import view_failed from '@/pages/sms/view_failed'
import send_view from '@/pages/sms/send_view'
import fail_list from '@/pages/sms/fail_list'
import my from '@/pages/my/index'
import sms_list from '@/pages/store/sms_list'
import select_template_store from '@/pages/sms/select_template_store'
import edit_templete from '@/pages/sms/edit_templete'
import send_history from '@/pages/sms/send_history.vue'
import templete_view from '@/pages/sms/templete_view.vue'
import templete_view2 from '@/pages/sms/templete_view2.vue'
import interact from '@/pages/interact/index.vue'
import vote from '@/pages/interact/vote.vue'
import vote_add from '@/pages/interact/vote_add.vue'
import qa from '@/pages/interact/qa.vue'
import qa_add from '@/pages/interact/qa_add.vue'
import liu from '@/pages/interact/liu.vue'
import data from '@/pages/interact/data.vue'
import visit from '@/pages/interact/visit.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },{
      path: '/select_template',
      name: 'select_template',
      component: select_template
    },{
      path: '/select_add',
      name: 'select_add',
      component: select_add
    },{
      path: '/import_data',
      name: 'import_data',
      component: import_data
    },{
      path: '/import_key',
      name: 'import_key',
      component: import_key
    },{
      path: '/import_data2',
      name: 'import_data2',
      component: import_data2
    },{
      path: '/import_key2',
      name: 'import_key2',
      component: import_key2
    },{
      path: '/view_results',
      name: 'view_results',
      component: view_results
    },{
      path: '/store',
      name: 'store',
      component: store
    },{
      path: '/send_result',
      name: 'send_result',
      component: send_result
    },{
      path: '/view_failed',
      name: 'view_failed',
      component: view_failed
    },{
      path: '/fail_list',
      name: 'fail_list',
      component: fail_list
    },{
      path: '/my',
      name: 'my',
      component: my
    },{
      path: '/sms_list',
      name: 'sms_list',
      component: sms_list
    },{
      path: '/select_template_store',
      name: 'select_template_store',
      component: select_template_store
    },{
      path: '/edit_templete',
      name: 'edit_templete',
      component: edit_templete
    },{
      path: '/send_history',
      name: 'send_history',
      component: send_history
    },{
      path: '/view_results2',
      name: 'view_results2',
      component: view_results2
    },{
      path: '/view_results3',
      name: 'view_results3',
      component: view_results3
    },{
      path: '/send_view',
      name: 'send_view',
      component: send_view
    },{
      path: '/templete_view',
      name: 'templete_view',
      component: templete_view
    },{
      path: '/templete_view2',
      name: 'templete_view2',
      component: templete_view2
    },{
      path: '/interact',
      name: 'interact',
      component: interact
    },{
      path: '/vote',
      name: 'vote',
      component: vote
    },{
      path: '/vote_add',
      name: 'vote_add',
      component: vote_add
    },{
      path: '/qa',
      name: 'qa',
      component: qa
    },{
      path: '/qa_add',
      name: 'qa_add',
      component: qa_add
    },{
      path: '/liu',
      name: 'liu',
      component: liu
    },{
      path: '/data',
      name: 'data',
      component: data
    },{
      path: '/visit',
      name: 'visit',
      component: visit
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js